import React, { ReactElement, ReactNode } from 'react';
import classNames from 'classnames';

import * as styles from './TeamGrid.module.css';

interface TeamGridProps {
  children: ReactNode;
  /** CSS class name */
  className?: string | string[];
  header?: string | ReactNode;
}

const TeamGrid = ({
  children,
  className,
  header,
}: TeamGridProps): ReactElement => {
  return (
    <div className={classNames('ce', className)}>
      {header}
      <div className={styles.ceTeamGridWrapper}>{children}</div>
    </div>
  );
};

TeamGrid.defaultProps = {
  header: null,
  className: null,
};

export default TeamGrid;
